import { registerEntityTabContribution } from '../lib/entityTabs';
import { ClientMattersTab, useClientMatters } from './panels/ClientMattersTab';
import { PropertyMatterTab, usePropertyMatters } from './panels/PropertyMatterTab';

/**
 * AppealStack Law self-registers its entity-tab contributions here. Imported ONCE at the
 * app root (main.tsx) — the single law→app FE seam, mirroring the backend
 * LANE_ROUTE_MODULES / registerFlagPack self-registration. Each contribution reads its own
 * flag (via useClientMatters → useLawEdition) and returns empty when the edition is off,
 * so a consulting firm's detail pages are byte-for-byte unchanged and this import is inert.
 */

// ClientDetail — a "Matters" tab listing the litigation matters that group this client's
// property appeals (count = the client's matter count). Absent when the edition is off.
registerEntityTabContribution<{ clientId: string }>('clients', ({ clientId }) => {
  const { mattersOn, matters } = useClientMatters(clientId);
  if (!mattersOn) return { items: [], panels: {} };
  return {
    items: [{ value: 'matters', label: 'Matters', count: matters.length }],
    panels: { matters: <ClientMattersTab clientId={clientId} /> },
  };
});

// PropertyDetail — a read-only "Matter" indicator: which litigation matter this property's
// appeals roll up into (a property carries no matter of its own; it links to the client's).
registerEntityTabContribution<{ propertyId: string }>('properties', ({ propertyId }) => {
  const { mattersOn, matters } = usePropertyMatters(propertyId);
  if (!mattersOn) return { items: [], panels: {} };
  return {
    items: [{ value: 'matter', label: 'Matter', count: matters.length || undefined }],
    panels: { matter: <PropertyMatterTab propertyId={propertyId} /> },
  };
});
